import { HealthLayout } from '@modules/health/health.layout';
import { EditAvaliacaoTmaPage } from '@modules/health/pages/avaliacao-tma/edit-avaliacao-tma';
import { PatientsPage } from '@modules/health/pages/patients';
import { PatientsEditPage } from '@modules/health/pages/patients/edit-patient';
import { ReportAvaliacaoTma } from '@modules/health/pages/reports/report-avaliacao-tma';
import { RouteObject } from 'react-router-dom';

export const healthRouter: RouteObject = {
  path: 'health',
  Component: HealthLayout,
  children: [
    { index: true, path: 'patients', element: <PatientsPage /> },
    { path: 'patients/:id', element: <PatientsEditPage /> },
    { path: 'patients/:patientId/avaliacaoTma/:id', element: <EditAvaliacaoTmaPage /> },
    { path: 'patients/:patientId/avaliacaoTma/:id/print', element: <ReportAvaliacaoTma /> },
  ],
};
